import { createAsyncThunk } from '@reduxjs/toolkit';

import CASE_STUDY from './caseStudy.api';

export const getCaseStudiesAction = createAsyncThunk<any, Study.GetStudyDetailPayload>(
  'case_study.getCaseStudies',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await CASE_STUDY.listCaseStudiesAPI(data)
      return res
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const createCaseStudiesAction = createAsyncThunk<
any,
Study.StudiesPostDetailPayload
>('create_CaseStudies', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await CASE_STUDY.createCaseStudiesAPI(data)
    return res
  } catch (err: any) {
    return rejectWithValue(err)
  }
})

export const updateCaseStudiesAction = createAsyncThunk<
any,
Study.StudiesPostDetailPayload
>('update_case_studies', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await CASE_STUDY.updateCaseStudiesAPI(data)
    return res
  } catch (err: any) {
    return rejectWithValue(err)
  }
})

export const deleteCaseStudiesAction = createAsyncThunk<any, Study.DeleteStudyPayload>(
  'delete_case_studies',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await CASE_STUDY.deleteCaseStudyAPI(data)
      return res
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)
